module.exports = __webpack_public_path__ + "img/linanbanner1.0e71fb42.jpg";